import { render, staticRenderFns } from "./NoDataSocialLearningLesson.vue?vue&type=template&id=0cdc6ef2&scoped=true&"
import script from "./NoDataSocialLearningLesson.vue?vue&type=script&lang=js&"
export * from "./NoDataSocialLearningLesson.vue?vue&type=script&lang=js&"
import style0 from "./NoDataSocialLearningLesson.vue?vue&type=style&index=0&id=0cdc6ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdc6ef2",
  null
  
)

export default component.exports